import { useParams } from "react-router-dom";
import { useGetSingleBatchQuery } from "../../../../features/portal/batch/batchApi";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import PaidListTableVendor from "./PaidListTableVendor";
import PendingListTableVendor from "./PendingListTableVendor";

export default function PaymentsVendorV2() {
  const roleCheck = localStorage.getItem("project_role");
  const { id } = useParams();
  const { data: singleBatchData } = useGetSingleBatchQuery(id);

  const singleBatch = singleBatchData?.data;

  return (
    <SidebarLayout
      title={singleBatch?.batchName}
      backLink="/admin/vendor-payment/batch"
    >
      <div>
        <PendingListTableVendor />
      </div>
      {roleCheck === "Maker" && (
        <div className="mt-[60px]">
          <PaidListTableVendor />
        </div>
      )}

      <div></div>
    </SidebarLayout>
  );
}
